module.exports = __webpack_public_path__ + "img/HF.38134c9d.svg";